export default function FormatDate(dateString) {
  const date = new Date(dateString);

  // Format options
  const options = { month: "short", day: "numeric", year: "numeric" };
  // Use Intl API for formatting
  return date.toLocaleDateString("en-US", options);
}